

export class Helpers {
    static LogInfo(value: any ,key: string="Value =>") {
        // console.log(`${key} =>`, value);
    }
    static LogError(value:any,key: string="Value =>"){
        console.error(value);
    }
       

}
